// src/api/managementApi.ts

import { baseApi } from './baseApi';
import type { ManagementSummary, UserCapacityDetail, ReassignmentResult, TeamRebalancingResult } from '../types/api';

export const managementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getManagementSummary: builder.query<ManagementSummary, void>({
      query: () => '/management/summary',
    }),
    getUserCapacityDetail: builder.query<UserCapacityDetail, string>({
      query: (userId) => `/management/capacity/${encodeURIComponent(userId)}`,
    }),
    getReassignmentSuggestions: builder.query<ReassignmentResult, string>({
      query: (taskId) => `/management/reassign/${encodeURIComponent(taskId)}`,
    }),
    getTeamRebalancingRecommendations: builder.query<TeamRebalancingResult, void>({
      query: () => '/management/rebalancing',
    }),
  }),
});

export const {
  useGetManagementSummaryQuery,
  useGetUserCapacityDetailQuery,
  useGetReassignmentSuggestionsQuery,
  useGetTeamRebalancingRecommendationsQuery,
} = managementApi;
